import { render, staticRenderFns } from "./AddMaterialsModal.vue?vue&type=template&id=b9f1ae64&scoped=true"
import script from "./AddMaterialsModal.vue?vue&type=script&lang=js"
export * from "./AddMaterialsModal.vue?vue&type=script&lang=js"
import style0 from "./AddMaterialsModal.vue?vue&type=style&index=0&id=b9f1ae64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f1ae64",
  null
  
)

export default component.exports